/**
 * HTTP layer for site-group operational reports. The compliance report feed
 * rolled up to the site-group level.
 *
 * Contains:
 * - fetchSiteGroupReports / fetchSiteGroupReport: list and detail reads
 */
import apiClient from '../http-common';

/**
 * API Client for Site Group Operational Reports
 * Handles aggregated operational reports for site groups with 30/60/90 day statistics
 */

/**
 * Fetch site group operational reports (aggregated view)
 * @param {Object} params - Query parameters
 * @param {number} params.site_group - Filter by site group ID
 * @param {string} params.search - Search by site name
 * @param {number} params.limit - Results per page
 * @param {number} params.offset - Pagination offset
 * @param {string} params.o - Ordering (e.g., 'site_name', '-pass_rate_30')
 * @returns {Promise} API response with aggregated site group reports
 */
export const fetchSiteGroupReports = params => {
  return apiClient.get('/site-group-operational-reports/', { params }).then(res => res.data);
};

/**
 * Fetch a single site group operational report
 * @param {number} id - Site group ID
 * @param {Object} params - Query parameters (limit, offset, search)
 * @returns {Promise} API response with detailed site group report including sites
 */
export const fetchSiteGroupReport = (id, params = {}) => {
  return apiClient.get(`/site-group-operational-reports/${id}/`, { params }).then(res => res.data);
};

export default {
  fetchSiteGroupReports,
  fetchSiteGroupReport,
};
